/* RISKS */
export const GET_RISKS = 'GET_RISKS';
export const GET_RISKS_SUCCESS = 'GET_RISKS_SUCCESS';
export const GET_RISKS_FAIL = 'GET_RISKS_FAIL';
